import AppStoreContext, { AppStore } from 'contexts/AppStoreContext';
import Immutable, { List } from 'immutable';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IntegrationsSelectedItem } from 'records/IntegrationsSelectedItem';
import { PageId } from 'records/Page';
import { ProjectDriveSelectedItem } from 'records/ProjectDriveSelectedItem';
import { StudioData } from 'records/RFI';
import { StudioProjectFileData } from 'records/StudioProjectFile';
import '../modals.css';
import InsertFilesModalFC from './InsertFilesModalFC';

export type InsertFilesOnSubmit = (values: InsertFilesSubmitParams) => void;

interface Props extends RouteComponentProps {
  onSubmit: InsertFilesOnSubmit;
  drawingsDisabled?: boolean;
}

class InsertFilesModal extends React.Component<Props, AppStore> {
  static modalClasses = {
    overlay: `modal__overlay`,
    content: `modal__window modal--lg`,
  };

  static modalStyles = {
    content: {
      width: '805px',
      height: '723px',
    },
  };

  static contextType = AppStoreContext;

  context!: React.ContextType<typeof AppStoreContext>;

  render(): React.ReactNode {
    const { onSubmit, drawingsDisabled } = this.props;

    return (
      <InsertFilesModalFC
        onSubmit={onSubmit}
        drawingsDisabled={drawingsDisabled}
      />
    );
  }
}

export type InsertFilesSubmitParams = {
  selectedPages: Immutable.Set<PageId>;
  projectDriveSelectedItems: List<ProjectDriveSelectedItem>;
  integrationsSelectedItems: List<IntegrationsSelectedItem>;
  studioItems: List<StudioProjectFileData>;
  studioProjectData: StudioData;
};

export default withRouter(InsertFilesModal);
